const MAX_LOGIN_ATTEMPTS = 5;
const LOGIN_TOKEN_TTL_REMAINING_THRESHOLD_IN_MINUTE = 7;
const MAX_REFRESH_TOKEN_ATTEMPT = 5;

export {
  MAX_LOGIN_ATTEMPTS,
  LOGIN_TOKEN_TTL_REMAINING_THRESHOLD_IN_MINUTE,
  MAX_REFRESH_TOKEN_ATTEMPT,
};
